document.querySelectorAll('[data-ampm-signup-success]').forEach((message) => {
  const disclosure = message.closest('[data-ampm-updates]');
  if (disclosure) disclosure.open = true;
  if (window.location.hash === `#${message.closest('form')?.id}`) message.focus({ preventScroll: true });
});
document.querySelectorAll('.ampm-signup [aria-invalid="true"]').forEach((input) => {
  const disclosure = input.closest('[data-ampm-updates]');
  if (disclosure) disclosure.open = true;
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-ampm-menu][open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-ampm-menu][open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
